import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { appConfig } from '../../config/config';

@Component({
    selector: 'app-main',
    standalone: true,
    imports: [],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './main.component.html',
    styleUrl: './main.component.scss',
})
export class MainComponent implements OnInit {
    token = toSignal(this.oidcSecurityService.getAccessToken(), { initialValue: null });
    config = appConfig;

    constructor(private oidcSecurityService: OidcSecurityService) {}

    ngOnInit() {
        const script = document.createElement('script');
        script.src = this.config.webchat.scriptUrl;
        script.type = 'module';
        document.body.appendChild(script);
    }
}
